export const cardData = [
  {
    id: 1,
    title: "Individual Schedule",
    text: "Efficiently manage your personal schedule with ease. Stay organized and never miss important appointments or events. Our platform helps you balance your personal and professional life.",
    iconColor: "#ddfbf9",
  },
  {
    id: 2,
    title: "Team Schedule",
    text: "Collaborate seamlessly within your team. Our scheduling solution allows you to coordinate tasks, meetings, and projects, ensuring everyone stays on track and meets deadlines.",
    iconColor: "#e7daf8",
  },
  {
    id: 3,
    title: "Project Management",
    text: "Streamline project planning and execution. Our tools enable you to allocate resources, set milestones, and monitor progress. Enhance team communication and achieve project success.",
    iconColor: "#ffede6",
  },
  {
    id: 4,
    title: "Schedule Automation",
    text: "Save time and reduce manual work with schedule automation. Our platform can automate repetitive tasks, reminders, and notifications, allowing you to focus on more important activities.",
    iconColor: "#ffe1e9",
  },
  {
    id: 5,
    title: "Real-Time Update",
    text: "Experience real-time updates and synchronization across all your devices. Any changes made to your schedule are instantly reflected, ensuring you have the latest information at your fingertips.",
    iconColor: "#dcedff",
  },
  {
    id: 6,
    title: "Secure",
    text: "Your data security is our priority. Our platform employs robust security measures to protect your sensitive information. Rest assured that your schedules and personal details are safe with us.",
    iconColor: "#dbf9ed",
  },
  {
    id: 7,
    title: "Scalable",
    text: "Our services grow with your needs. Whether you're an individual, a small team, or a large organization, our scalable solutions can adapt to your changing requirements, ensuring continued efficiency.",
    iconColor: "#fffada",
  },
  {
    id: 8,
    title: "More",
    text: "Explore additional features and benefits of our schedule services. From integrations with other tools to customizable templates, there's always more to discover for enhancing your scheduling experience.",
    iconColor: "#ffffff",
  },
];
